export const version = 'kunde-v1.20.0-SNAPSHOT-a3a2f8aee0eb9c750c70900d689f133a40c90db7';